import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06ed67ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-container" }
const _hoisted_2 = { class: "d-flex bottom" }
const _hoisted_3 = { class: "col-9 col-md-10 left" }
const _hoisted_4 = { class: "col-3 col-md-2 right" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex bottom"
}
const _hoisted_6 = { class: "col-9 col-md-10 left" }
const _hoisted_7 = { class: "mb-1" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "mb-1" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "mb-1" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "col-3 col-md-2 right" }
const _hoisted_14 = {
  key: 1,
  class: "d-flex bottom"
}
const _hoisted_15 = { class: "col-9 col-md-10 left" }
const _hoisted_16 = { class: "mb-1" }
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "mb-1" }
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "mb-1" }
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "col-3 col-md-2 right" }
const _hoisted_23 = {
  key: 2,
  class: "d-flex bottom"
}
const _hoisted_24 = { class: "col-9 col-md-10 left" }
const _hoisted_25 = { class: "mb-1" }
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "mb-1" }
const _hoisted_28 = ["href"]
const _hoisted_29 = { class: "mb-1" }
const _hoisted_30 = ["href"]
const _hoisted_31 = { class: "mb-1" }
const _hoisted_32 = ["href"]
const _hoisted_33 = { class: "col-3 col-md-2 right" }
const _hoisted_34 = { class: "d-flex bottom" }
const _hoisted_35 = { class: "col-9 col-md-10 left" }
const _hoisted_36 = { class: "mb-1" }
const _hoisted_37 = ["href"]
const _hoisted_38 = { class: "mb-1" }
const _hoisted_39 = ["href"]
const _hoisted_40 = { class: "mb-1" }
const _hoisted_41 = ["href"]
const _hoisted_42 = { class: "mb-1" }
const _hoisted_43 = ["href"]
const _hoisted_44 = { class: "col-3 col-md-2 right" }
const _hoisted_45 = { class: "d-flex bottom" }
const _hoisted_46 = { class: "col-9 col-md-10 left" }
const _hoisted_47 = { class: "col-3 col-md-2 right" }
const _hoisted_48 = { class: "d-flex bottom" }
const _hoisted_49 = { class: "col-9 col-md-10 left" }
const _hoisted_50 = { class: "col-3 col-md-2 right" }
const _hoisted_51 = { class: "d-flex bottom" }
const _hoisted_52 = { class: "col-9 col-md-10 left" }
const _hoisted_53 = { class: "col-3 col-md-2 right" }
const _hoisted_54 = { class: "d-flex bottom" }
const _hoisted_55 = { class: "col-9 col-md-10 left" }
const _hoisted_56 = { class: "col-3 col-md-2 right" }
const _hoisted_57 = { class: "d-flex bottom" }
const _hoisted_58 = { class: "col-9 col-md-10 left" }
const _hoisted_59 = { class: "col-3 col-md-2 right" }
const _hoisted_60 = { class: "d-flex" }
const _hoisted_61 = { class: "col-9 col-md-10 left" }
const _hoisted_62 = { class: "text-decoration-underline" }
const _hoisted_63 = { class: "col-3 col-md-2 right" }

import { ref, onMounted, inject } from "vue";
import { accountTypes } from "@/core/types/jp/verificationFinancial";
import { jpDocs } from "@/core/data/bcrDocs";

export default /*#__PURE__*/_defineComponent({
  __name: 'JpAgreement',
  setup(__props) {

const formData = inject<any>("formData");
const verificationDetails = inject<any>("verificationDetails");
const disabled = inject<any>("disabled");
const item = ref<any>(verificationDetails.value.financial);
onMounted(() => {
  formData.value = verificationDetails.value.agreement;
});

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("type.jpAgreement.check1")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_form_item, {
          prop: "check_1",
          class: "d-flex align-items-center justify-content-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox, {
              modelValue: _unref(formData).check_1,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).check_1) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("fields.iAccept")), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    (item.value.accountTypes.includes(_unref(accountTypes).margin))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", {
                href: _unref(jpDocs).foreignExchangeMarginTrading.src,
                target: "_blank",
                class: "pdf"
              }, _toDisplayString(_unref(jpDocs).foreignExchangeMarginTrading.title), 9, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("a", {
                href: _unref(jpDocs).foreignExchangeTermsAndConditions.src,
                target: "_blank",
                class: "pdf"
              }, _toDisplayString(_unref(jpDocs).foreignExchangeTermsAndConditions.title), 9, _hoisted_10)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("a", {
                href: _unref(jpDocs).foreginExchangeTradingManual.src,
                target: "_blank",
                class: "pdf"
              }, _toDisplayString(_unref(jpDocs).foreginExchangeTradingManual.title), 9, _hoisted_12)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_el_form_item, {
              prop: "check_2",
              class: "d-flex align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _unref(formData).check_2,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).check_2) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("fields.iAccept")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (item.value.accountTypes.includes(_unref(accountTypes).cfdTrading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("a", {
                href: _unref(jpDocs).foreignExchangeMarginTrading.src,
                target: "_blank",
                class: "pdf"
              }, _toDisplayString(_unref(jpDocs).foreignExchangeMarginTrading.title), 9, _hoisted_17)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("a", {
                href: _unref(jpDocs).cfdTradingTermsAndConditions.src,
                target: "_blank",
                class: "pdf"
              }, _toDisplayString(_unref(jpDocs).cfdTradingTermsAndConditions.title), 9, _hoisted_19)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("a", {
                href: _unref(jpDocs).cfdTradingManual.src,
                target: "_blank",
                class: "pdf"
              }, _toDisplayString(_unref(jpDocs).cfdTradingManual.title), 9, _hoisted_21)
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_el_form_item, {
              prop: "check_3",
              class: "d-flex align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _unref(formData).check_3,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).check_3) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("fields.iAccept")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (item.value.accountTypes.includes(_unref(accountTypes).productTrading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("a", {
                href: _unref(jpDocs).productCfdTrading.src,
                target: "_blank",
                class: "pdf"
              }, _toDisplayString(_unref(jpDocs).productCfdTrading.title), 9, _hoisted_26)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("a", {
                href: _unref(jpDocs).commodityCfdTradingTermsAndConditions.src,
                target: "_blank",
                class: "pdf"
              }, _toDisplayString(_unref(jpDocs).commodityCfdTradingTermsAndConditions.title), 9, _hoisted_28)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("a", {
                href: _unref(jpDocs).productCfdTradingManual.src,
                target: "_blank",
                class: "pdf"
              }, _toDisplayString(_unref(jpDocs).productCfdTradingManual.title), 9, _hoisted_30)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("a", {
                href: _unref(jpDocs).productCfdTradingForCorporations.src,
                target: "_blank",
                class: "pdf"
              }, _toDisplayString(_unref(jpDocs).productCfdTradingForCorporations.title), 9, _hoisted_32)
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_el_form_item, {
              prop: "check_4",
              class: "d-flex align-items-center justify-content-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _unref(formData).check_4,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).check_4) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("fields.iAccept")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("a", {
            href: _unref(jpDocs).agreementRegardingElectronicDelivery.src,
            target: "_blank",
            class: "pdf"
          }, _toDisplayString(_unref(jpDocs).agreementRegardingElectronicDelivery.title), 9, _hoisted_37)
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("a", {
            href: _unref(jpDocs).personalInformationProtectionDeclaration.src,
            target: "_blank",
            class: "pdf"
          }, _toDisplayString(_unref(jpDocs).personalInformationProtectionDeclaration.title), 9, _hoisted_39)
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("a", {
            href: _unref(jpDocs).agreementForAntiSocialForce.src,
            target: "_blank",
            class: "pdf"
          }, _toDisplayString(_unref(jpDocs).agreementForAntiSocialForce.title), 9, _hoisted_41)
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("a", {
            href: _unref(jpDocs).notificationOfNotFallingUnderForeignPeps.src,
            target: "_blank",
            class: "pdf"
          }, _toDisplayString(_unref(jpDocs).notificationOfNotFallingUnderForeignPeps.title), 9, _hoisted_43)
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createVNode(_component_el_form_item, {
          prop: "check_5",
          class: "d-flex align-items-center justify-content-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox, {
              modelValue: _unref(formData).check_5,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formData).check_5) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("fields.iAccept")), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", null, "①" + _toDisplayString(_ctx.$t("type.jpAgreement.check2Title")), 1),
        _createElementVNode("div", null, _toDisplayString(_ctx.$t("type.jpAgreement.check2")), 1)
      ]),
      _createElementVNode("div", _hoisted_47, [
        _createVNode(_component_el_form_item, {
          prop: "check_6",
          class: "d-flex align-items-center justify-content-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox, {
              modelValue: _unref(formData).check_6,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formData).check_6) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.yes")), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_48, [
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("div", null, "②" + _toDisplayString(_ctx.$t("type.jpAgreement.check3Title")), 1),
        _createElementVNode("div", null, _toDisplayString(_ctx.$t("type.jpAgreement.check3")), 1)
      ]),
      _createElementVNode("div", _hoisted_50, [
        _createVNode(_component_el_form_item, {
          prop: "check_7",
          class: "d-flex align-items-center justify-content-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox, {
              modelValue: _unref(formData).check_7,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formData).check_7) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.yes")), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", null, "③" + _toDisplayString(_ctx.$t("type.jpAgreement.check4Title")), 1),
        _createElementVNode("div", null, _toDisplayString(_ctx.$t("type.jpAgreement.check4")), 1)
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createVNode(_component_el_form_item, {
          prop: "check_8",
          class: "d-flex align-items-center justify-content-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox, {
              modelValue: _unref(formData).check_8,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formData).check_8) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.yes")), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_54, [
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", null, "④" + _toDisplayString(_ctx.$t("type.jpAgreement.check5Title")), 1),
        _createElementVNode("div", null, _toDisplayString(_ctx.$t("type.jpAgreement.check5")), 1)
      ]),
      _createElementVNode("div", _hoisted_56, [
        _createVNode(_component_el_form_item, {
          prop: "check_9",
          class: "d-flex align-items-center justify-content-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox, {
              modelValue: _unref(formData).check_9,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(formData).check_9) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.yes")), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_57, [
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", null, "⑤" + _toDisplayString(_ctx.$t("type.jpAgreement.check6Title")), 1),
        _createElementVNode("div", null, _toDisplayString(_ctx.$t("type.jpAgreement.check6")), 1)
      ]),
      _createElementVNode("div", _hoisted_59, [
        _createVNode(_component_el_form_item, {
          prop: "check_10",
          class: "d-flex align-items-center justify-content-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox, {
              modelValue: _unref(formData).check_10,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(formData).check_10) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.yes")), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.$t("type.jpAgreement.check7")), 1)
      ]),
      _createElementVNode("div", _hoisted_63, [
        _createVNode(_component_el_form_item, {
          prop: "check_11",
          class: "d-flex align-items-center justify-content-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox, {
              modelValue: _unref(formData).check_11,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(formData).check_11) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.yes")), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})